import Vue from 'vue'
import Host from '@config/host'

const EventBus = new Vue()

EventBus.$on('app-load', () => {
  const target = document.getElementById('appStart')
  target.classList.add('hide')
})

// 默认监听的全局时间
EventBus.$on('CODE_NO_LOGIN', () => {
  location.href = Host.me + '/login?system_id=partner&return_url=' + encodeURIComponent(location.href)
})

export default EventBus